// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3G8bq","emails":"CreateEditClinics_emails__7uZJm","emailTagLabel":"CreateEditClinics_emailTagLabel__2deQj"};